import { type QuickRangeId, type QuickRangeOption, QUICK_RANGE_OPTIONS } from 'common/components';
import { DateRangeType } from 'services/hooks/queries';

const DASHBOARD_QUICK_RANGE_IDS: QuickRangeId[] = ['today', 'yesterday', 'last7', 'last30'];

export const DASHBOARD_QUICK_RANGE_OPTIONS: QuickRangeOption[] = QUICK_RANGE_OPTIONS.filter((option) =>
    DASHBOARD_QUICK_RANGE_IDS.includes(option.id)
);

type DateRangeTypeKey = keyof typeof DateRangeType;

/** Maps slai-ui quick presets to legacy chart grouping keys. Unknown presets use `custom`. */
export const quickRangeIdToDateRangeType = (quickRangeId: QuickRangeId | null): DateRangeTypeKey => {
    switch (quickRangeId) {
        case 'today':
            return DateRangeType.today;
        case 'yesterday':
            return DateRangeType.yesterday;
        case 'last7':
            return DateRangeType.last7Days;
        case 'last30':
            return DateRangeType.last30Days;
        default:
            return DateRangeType.custom;
    }
};

export const isTodayQuickRange = (quickRangeId: QuickRangeId | null): boolean => quickRangeId === 'today';
